// extracted by mini-css-extract-plugin
module.exports = {"container":"zh","heading":"Ah","linkBtn":"Bh","disabled":"Ch","linkUppercaseBold":"Dh","copy":"Eh","links":"Fh"};